import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Grow from '@material-ui/core/Grow';
import ArticleList from '../article-list';

class Order extends Component {
  renderPreOrderTime() {
    const { classes, value } = this.props;

    if (!value.pickupTimeIsSet) {
      return null;
    }

    const label = value.isDelivery ? 'Lieferzeit' : 'Abholzeit';

    return (
      <div>
        <Typography className={classes.headerLabel} color="textSecondary">{label}</Typography>
        <Typography className={classes.inlineTypography}>{value.pickupTime}</Typography>
      </div>
    );
  }

  renderTelephone() {
    const { value, classes } = this.props;

    const { telephone, isDelivery } = value;

    if (!telephone || isDelivery) {
      return null;
    }

    return (
      <div>
        <Typography className={classes.headerLabel} color="textSecondary">Tel.</Typography>
        <Typography className={classes.inlineTypography}>{telephone}</Typography>
      </div>
    );
  }

  renderCardActions = () => {
    const { classes, value, declineOrder, proceedOrder, hideActions } = this.props;

    if (hideActions) {
      return null;
    }

    const buttonStyle = {
      color: value.proceedColor,
    };


    const declineButton = value.canReject
      ? (<Button
        variant="outlined"
        style={buttonStyle}
        className={classes.button}
        disabled={value.loading}
        onClick={() => declineOrder(value.id)}
      >
      Ablehnen
      </Button>)
      : null;

    const proceedButton = value.proceedText
      ? (<Button
        variant="outlined"
        style={buttonStyle}
        className={classes.button}
        disabled={value.loading}
        onClick={() => proceedOrder(value.id)}
      >
        {value.proceedText}
      </Button>)
      : null;

    return (
      <CardActions className={classes.cardAction}>
        {declineButton}
        {proceedButton}
      </CardActions>
    );
  }

  render() {
    const { classes, value, openDeliveryDialog } = this.props;

    const cardClass = value.loading ? classes.disabledCard : null;
    const loadingIndicator = value.loading
      ? <LinearProgress />
      : null;

    const note = value.userNote
      ? <Typography className={classes.userNote}>{value.userNote}</Typography>
      : null;


    const cardStyle = {
      backgroundColor: value.color,
    };

    const label = value.isDelivery ? 'Lieferung an' : 'Abholer';

    return (
      <Grow in={value.show}>
        <div className={classes.root}>
          <Card className={cardClass} style={cardStyle}>
            <CardContent className={classes.cardContent}>
              <div>
                {loadingIndicator}

                <div className={classes.header} onClick={() => openDeliveryDialog(value)}>
                  <div>
                    <Typography className={classes.headerLabel} color="textSecondary">{label}</Typography>
                    <Typography className={classes.inlineTypography}>{value.pickupName}</Typography>
                    <Typography className={classes.inlineTypography}>/</Typography>
                    <Typography className={classes.inlineTypography}>{value.pickupCode}</Typography>
                  </div>
                  {this.renderPreOrderTime()}
                  {
                    value.isDelivery ?
                      (
                        <div>
                          <Typography className={classes.inlineTypographyDotted}>Adresse {'&'} Kontakt anzeigen</Typography>
                        </div>
                      ) : null
                  }
                  {this.renderTelephone()}
                </div>

                {note}

                <div className={classes.articleList}>
                  <ArticleList value={value.articles} />
                </div>
              </div>
            </CardContent>
            {this.renderCardActions()}
          </Card>
        </div>
      </Grow>
    );
  }
}

const styles = theme => ({
  button: {
    fontSize: theme.order.buttons.fontSize,
  },
  cardContent: {
    padding: 0,
  },
  header: {
    padding: 16,
  },
  headerLabel: {
    display: 'inline-block',
    width: 120,
  },
  inlineTypography: {
    display: 'inline-block',
  },
  inlineTypographyDotted: {
    display: 'inline-block',
    textDecoration: 'underline dotted',
    fontSize: 14,
  },
  articleList: {

  },
  cardAction: {
    float: 'right',
  },
  note: {
    padding: '0 16px',
    color: theme.palette.error.dark,
  },
});

Order.defaultProps = {
  hideActions: false,
}

Order.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired,
  proceedOrder: PropTypes.func.isRequired,
  declineOrder: PropTypes.func.isRequired,
  openDeliveryDialog: PropTypes.func.isRequired,
  hideActions: PropTypes.bool,
};

export default withStyles(styles)(Order);
